import { CustomState } from "@gerrieDev/Store/Reducers";

export function getStatementLines(state: CustomState) {
    return state.statementLinesReducer;
}

